/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RobotTypeEnum {
  SWEEPER = 'Sweeper',
  COMBO = 'Combo',
}
